import { render } from "./Pulmonologist.vue?vue&type=template&id=2cc3f4dc&scoped=true"
import script from "./Pulmonologist.vue?vue&type=script&lang=js"
export * from "./Pulmonologist.vue?vue&type=script&lang=js"

import "./Pulmonologist.vue?vue&type=style&index=0&id=2cc3f4dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cc3f4dc"

export default script